module.exports = __webpack_public_path__ + "img/fig03.3a763cff.jpg";